import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-recompose';

import { push as Push } from 'redux-first-history';

import { ApplicationState as State } from '@api/store';
import { AccountStartUpdate, ValidateInput, AccountUpdateGlobalContacts } from '@api/store/account/actions';
import { AdvancedProps as Props } from './AdvancedInterface';
import { AdvancedOptions } from '@dev/ee-api/ee-api-models';
import { ValidationType } from '@api/store/account/types';
import { Advanced as Screen } from '@dev/ee-modules';
import { SettingsPaths } from '@api/services/dictionaries/paths';
import { useDashboardElementVisibility } from '@api/services/hooks/useDashboardElementVisibility';

const mapState = (state: State, ownProps: Props): Props => {
    return {
        ...ownProps,
        account: state.account,
        browser: state.browser,
    };
};
const dispatchProps = {
    AccountStartUpdate,
    AccountUpdateGlobalContacts,
    ValidateInput,
    Push,
};
interface DispatchProps {
    AccountStartUpdate(option: keyof AdvancedOptions, value: string | number | boolean): any;
    ValidateInput(options: AdvancedOptions, type: ValidationType): void;
    Push(url: string): void;
    AccountUpdateGlobalContacts(value): any;
}
type ExtendedProps = Props & DispatchProps;

const Advanced = (props: ExtendedProps): JSX.Element => {
    const {
        settings: { isSettingsPanelVisible },
    } = useDashboardElementVisibility();

    return <Screen paths={SettingsPaths} isSettingsPanelVisible={isSettingsPanelVisible} {...props} />;
};

export default compose(connect<Props, DispatchProps>(mapState, dispatchProps))(Advanced);
